import React, { useMemo } from 'react';
import clsx from 'clsx';
import { Icons, Checkbox, IconButton, ListItem, ListItemIcon, ListItemText, ListItemButton, Stack, Tooltip } from "@curves/ui-base";
import { attentionArray } from '@icoach/landingPage/checkin/CheckinTable';
import PropTypes from 'prop-types';
import { isEqual } from "lodash";

const TodoItem = ({ todo, onToggleCompleted, onDeleteItem }) => {
    const { taskTitle, taskID, reminderConditionType = 2, isCompleted = false } = todo;

    // 依照 `reminderConditionType` 取得對應的 Icon
    const Icon = useMemo(() => attentionArray.find((item) => isEqual(reminderConditionType, item.id))?.Icon || '', [reminderConditionType]);

    return (
        <ListItem className={clsx('todo__item', isCompleted && 'todo__item--completed')} disableGutters dense>
            <ListItemButton onClick={() => onToggleCompleted(todo)}>
                <Stack className="w-100" alignItems={'center'}>
                    <ListItemIcon>
                        <Checkbox key={isCompleted} onChange={() => onToggleCompleted(todo)} defaultChecked={isCompleted} disableRipple />
                    </ListItemIcon>
                    <ListItemIcon>{Icon ? <Icon /> : <Icons.Todo />}</ListItemIcon>
                    <ListItemText primary={taskTitle} />
                </Stack>
            </ListItemButton>
            <Tooltip title="刪除">
                <IconButton className={'todo__item__delete-button'} onClick={() => onDeleteItem(taskID)}>
                    <Icons.ErrorCircle />
                </IconButton>
            </Tooltip>
        </ListItem>
    );
};

TodoItem.propTypes = {
    todo: PropTypes.shape({
        taskID: PropTypes.number.isRequired,
        taskTitle: PropTypes.string.isRequired,
        reminderConditionType: PropTypes.number,
        isCompleted: PropTypes.bool,
    }).isRequired,
    onToggleCompleted: PropTypes.func.isRequired,
    onDeleteItem: PropTypes.func.isRequired,
};

export default TodoItem;
